module.exports = __webpack_public_path__ + "static/smile-smock-d3299c82c70c7e2e57ec8c0da5e3324a.png";